<mat-dialog-content class="cookies-consent-content">
  <div class="cookies-content" [innerHTML]="'dialogs.cookies.content' | translate"></div>

  <ng-container *ngFor="let group of items">
    <h4 class="flex-row align-items-center justify-content-between">
      <label class="flex-row align-items-center" id="group_{{ group.title }}"><button *ngIf="customize" mat-icon-button
          class="text-primary" (click)="group.collapsed = !group.collapsed"
          [attr.data-cy]="'toggle-collapse-' + group._type">
          <i class="ri-arrow-right-s-line"></i></button>{{ group.title | translate }}</label>
      <mat-slide-toggle aria-labelledby="group_{{ group.title }}" [checked]="group.allAccepted"
        (change)="toggleGroup($event, group)" [disabled]="group.needed"></mat-slide-toggle>
    </h4>
    <p *ngIf="!!group.description">{{ group.description | translate }}</p>
    <div *ngIf="!group.collapsed">
      <ng-container *ngFor="let item of group.items">
        <div class="flex-row align-items-center justify-content-between">
          <label id="label_{{ item.title }}" class="flex-row align-items-center">
            {{ item.title | translate }}

            <i class="ri-information-line ms-2" *ngIf="item.description"
              [matTooltip]="item.description | translate"></i>
          </label><mat-slide-toggle [checked]="item.accepted" aria-label="{{ item.title }}"
            (change)="toggle($event, group, item)"></mat-slide-toggle>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <div mat-dialog-actions class="flex-row justify-content-center justify-content-lg-end">
    <button class="btn btn-flat-primary" (click)="rejectAll()" data-cy="button-reject-all-cookies">
      {{ 'button.reject_all' | translate }}
    </button>

    <ng-container *ngIf="!customized; else acceptSelectedTpl">
      <button class="btn btn-primary" (click)="acceptAll()" data-cy="button-accept-all-cookies">
        {{ 'button.accept_all' | translate }}
      </button>
    </ng-container>

    <ng-template #acceptSelectedTpl>
      <button class="btn btn-primary" (click)="submit()" data-cy="button-accept-selected-cookies">
        {{ 'button.accept_selected' | translate }}
      </button>
    </ng-template>
  </div>
</mat-dialog-content>
